import * as React from 'react';
import '../../_assets/css/file.css';
import axios from 'axios';

import { baseURL } from '../../_helpers';
import { Card, CardBody, Col, Button } from 'reactstrap';
import { Redirect } from 'react-router-dom';
import PhoneOutlineIcon from 'mdi-react/PhoneOutlineIcon';
import Input from 'react-phone-number-input/input'

export class UserSearchLuckyNumber extends React.Component {

    constructor(props) {
        super(props)


        this.onSubmit = this.onSubmit.bind(this);
        this.state = {
            phone_number: '',
            showError: false,
            isShowError: false,
        }
    }




    onSubmit(e) {
        e.preventDefault();


        let formData = {
            "msisdn": this.state.phone_number
        }

        console.log("DATA", JSON.stringify(formData))
        this.setState({ isLoading: true });

        axios.get(baseURL + 'customersonelucky/' + this.state.phone_number.replaceAll("+", ""), {
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            },
        }).then((response) => {
            console.log("bayo", response.data)
            if (response.data.status) {

                this.setState({
                    statusMessage: "Success! Redirecting....",
                    isShowError: true, isLoading: false, showError: false,

                });
                // alert(response.data.msisdn)
                localStorage.setItem('phone', this.state.phone_number.replaceAll("+", ""))
                //   localStorage.setItem('balance', response.data.balance)
                //   localStorage.setItem('balance', response.data.netCashValue)
                //   localStorage.setItem('mtime', response.data.time)

                window.setTimeout(function () {
                    window.location.href = "/user_details_lucky";
                    this.setState({
                        statusMessage: response.data.message,
                        isShowError: true, isLoading: false, showError: false,
                    });
                }, 1000);

            } else {

                this.setState({ statusMessage: response.data.message, showError: true, isShowError: false, isLoading: false });
            }
        }).catch(error => {
            console.log('bayoo', error.response)
            this.setState({
                showError: true,
                isShowError: false,
                statusMessage: error.response.data.message,
                submitted: true,
                isLoading: false
            });
        });


    }
    handleChange = (e) => {
        this.setState({ [e.target.name]: e.target.value });
    }

    render() {
        const { showComponent } = this.state;
        const { hideComponent } = this.state;

        return (
            <div className="pcoded-main-container">

                {showComponent && (
                    <div>

                        {this.state.showComponent ?
                            <peopleView /> : null
                        }

                    </div>
                )}

                {!hideComponent && (
                    <>

                        <Col md={12}>
                            <h4>User Search SuperSorte</h4><br />

                        </Col>
                        <Col md={12} lg={12}>
                            <Card>
                                <CardBody><br />

                                    <div className="card__title">
                                        <h5 className="bold-text">Fill the Below Field to search SuperSorte User</h5>
                                    </div>

                                    {this.state.showError ? <div style={{ color: 'red' }}>
                                        {this.state.statusMessage}

                                    </div> : null}<br></br>

                                    {this.state.isShowError ? (
                                        <div
                                            color="success"
                                            style={{ fontSize: "13px", color: "green" }}>
                                            {this.state.statusMessage}
                                        </div>

                                    ) : null}<br></br>
                                    <form className="col-md-8 offset-md-2" onSubmit={this.onSubmit}>


                                        <div className="form-group">
                                            <label className="form-label">Customer Phone</label>
                                            <div className="form__form-group-field">
                                                <div className="form__form-group-icon">
                                                    <PhoneOutlineIcon />
                                                </div>
                                                <Input
                                                    country="MZ"
                                                    international
                                                    withCountryCallingCode
                                                    required
                                                    className="form-control"
                                                    placeholder="Ваш телефон"
                                                    name="phone_number"
                                                    id="input"
                                                    value={this.state.phone_number}
                                                    onChange={value => this.setState({ phone_number: value })} />
                                            </div>

                                        </div>
                                        <br />
                                        <div className="col-md-12">
                                            <Button type="submit" outline color="primary" className="btn-paypal btn-lg pull-right" >
                                                {this.state.isLoading ? "Please Wait..." : "Search"}  <i className="fa fa-search"></i></Button> &nbsp;&nbsp;&nbsp;
                                        </div>
                                    </form>
                                </CardBody>
                            </Card>
                        </Col>
                    </>

                )
                }

            </div>
        )

    }

}
